export default defineNuxtPlugin(() => {
  if (process.client) {
    const gtmId = useRuntimeConfig().public.GTM_ID || "GTM-XXXXXXX"; // fallback
    const additionalGtmId = "GTM-P5HR7N6"; // Additional GTM container

    // Function to load GTM container
    const loadGTMContainer = (containerId: string) => {
      // <script> for head
      const script = document.createElement("script");
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${containerId}');
      `;
      document.head.appendChild(script);

      // <noscript> iframe for body
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";

      const noscript = document.createElement("noscript");
      noscript.appendChild(iframe);

      document.body.prepend(noscript);
    };

    // Load primary GTM container (from environment)
    loadGTMContainer(gtmId);
    
    // Load additional GTM container
    loadGTMContainer(additionalGtmId);
  }
});
